// Curated Template Store taxonomy used by the publish dropdowns. Categories map
// to their allowed subcategories. Derived from the marketplace template set so
// the store stays consistently organized instead of accumulating typo'd
// free-text categories.
var SUBCATEGORIES_BY_CATEGORY = {
  Business: [
    'AI Ops',
    'AI Summarization',
    'Content Engine',
    'Customer Success',
    'Customer Support',
    'Engineering',
    'Finance & Ops',
    'Inbox Ops',
    'Knowledge Ops',
    'Market Intelligence',
    'Ops & Monitoring',
    'Product',
    'Reporting & Docs',
    'Sales & Lead Gen',
    'Team Ops'
  ],
  Personal: [
    'Career',
    'Daily Briefs',
    'Health & Habits',
    'Home & Wellness',
    'Inbox Ops',
    'Learning',
    'Lifestyle',
    'Money & Investing',
    'Money & Spending',
    'Productivity',
    'Relationships',
    'Shopping & Money',
    'Travel'
  ]
};

var CATEGORY_OPTIONS = Object.keys(SUBCATEGORIES_BY_CATEGORY);

function getSubcategories(category) {
  return SUBCATEGORIES_BY_CATEGORY[category] || [];
}

module.exports = {
  CATEGORY_OPTIONS: CATEGORY_OPTIONS,
  SUBCATEGORIES_BY_CATEGORY: SUBCATEGORIES_BY_CATEGORY,
  getSubcategories: getSubcategories
};
